"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEPAQRGenerator = void 0;
const qrcode_1 = __importDefault(require("qrcode"));
class SEPAQRGenerator {
    constructor(options = {}) {
        this.options = {
            errorCorrectionLevel: 'M',
            margin: 4,
            scale: 4,
            ...options
        };
    }
    validateData(data) {
        if (!data.name || !data.iban) {
            throw new Error('Missing required fields: name and iban');
        }
        if (data.bic && !/^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(data.bic)) {
            throw new Error('Invalid BIC format');
        }
        if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/.test(data.iban)) {
            throw new Error('Invalid IBAN format');
        }
        if (data.amount && !/^\d+(\.\d{1,2})?$/.test(data.amount)) {
            throw new Error('Invalid amount format');
        }
        if (data.currency && !/^[A-Z]{3}$/.test(data.currency)) {
            throw new Error('Invalid currency code');
        }
        if (data.purposeCode && !/^[A-Z]{4}$/.test(data.purposeCode)) {
            throw new Error('Invalid purpose code format');
        }
    }
    generateContent(data) {
        this.validateData(data);
        const content = [
            'BCD',
            '002',
            '1',
            'SCT',
            data.bic || '',
            data.name,
            data.iban,
            (data.currency || 'EUR') + (data.amount || '1'),
            data.purposeCode || '',
            data.remittanceInfo || '',
            data.beneficiaryToOriginator || ''
        ];
        return content.join('\n');
    }
    async generateQRCode(data, outputType = 'base64') {
        const content = this.generateContent(data);
        try {
            switch (outputType) {
                case 'base64':
                    return await qrcode_1.default.toDataURL(content, {
                        errorCorrectionLevel: this.options.errorCorrectionLevel,
                        margin: this.options.margin,
                        scale: this.options.scale,
                    });
                case 'buffer':
                    return await qrcode_1.default.toBuffer(content, {
                        errorCorrectionLevel: this.options.errorCorrectionLevel,
                        margin: this.options.margin,
                        scale: this.options.scale,
                    });
                case 'utf8':
                    return content;
                default:
                    throw new Error(`Unsupported output type: ${outputType}`);
            }
        }
        catch (err) {
            if (err instanceof Error) {
                throw new Error(`Failed to generate QR code: ${err.message}`);
            }
            else {
                throw new Error('Failed to generate QR code: Unknown error');
            }
        }
    }
}
exports.SEPAQRGenerator = SEPAQRGenerator;
